<script setup lang="ts">
    import BsFormContainer from "@songfinch/customer/views/build_song/chapters/BsFormContainer";
    import RequiredFormHelper from "@songfinch/shared/components/RequiredFormHelper";
    import LabelOption from "@songfinch/customer/components/song_builder/LabelOption.vue";
    import StepTipCard from "@songfinch/customer/components/song_builder/StepTipCard.vue";

    import {computed, ref} from "vue";
    import {useStore} from "vuex";
    import {useRoute} from "vue-router";
    import useBsFormChapters from "@songfinch/customer/composables/songBuilder/useBsFormChapters";
    import {useSongBuilderStore} from "@songfinch/customer/store_v2/useSongBuilderStore";
    const storeSongBuilder = useSongBuilderStore();

    const {CmsData} = useBsFormChapters();
    const store = useStore();
    const route = useRoute();
    const preferredArtistSwitch = ref(storeSongBuilder.preferred_artist_switch);
    const showUnavailableContent = computed(() => route.query.artist_unavailabe || storeSongBuilder.require_update_artist);

    if (route.query.artist_unavailabe) {
        storeSongBuilder.selectRecommendedArtist(undefined);
        storeSongBuilder.clearSelectedArtists();
        storeSongBuilder.require_update_artist = true;
        storeSongBuilder.saveData();
    }

    async function validate() {
        const saved = storeSongBuilder.preferred_artist_switch;
        if (saved === undefined) return true;
        if (saved !== preferredArtistSwitch.value && (storeSongBuilder.selected_artists?.length || storeSongBuilder.selected_recommended_artist)) {
            return await store.dispatch("shared/confirmationModal", {
                html: `<div class="p3">By changing this option, you will clear your artist selection. Do you want to continue?</div>`,
                confirmButtonText: "Continue",
            });
        }
        return true;
    }

    function save() {
        storeSongBuilder.preferred_artist_switch = preferredArtistSwitch.value;
        if (storeSongBuilder.preferred_artist_switch) {
            storeSongBuilder.selectRecommendedArtist(undefined);
            storeSongBuilder.setRecommendedArtists(undefined);
        } else {
            storeSongBuilder.clearSelectedArtists();
        }
    }
</script>

<template>
    <div class="bsSubs text-center">
        <BsFormContainer :validator="validate" @next="save">
            <h3 class="@mb-4 @max-w-475 @mx-auto" v-html="showUnavailableContent ? CmsData.title_not_available : CmsData.title"/>
            <div class="p3 @mb-8 @max-w-375 @mx-auto cmsContent" v-html="showUnavailableContent ? CmsData.content_below_not_available : CmsData.content_below"/>
            <div class="tablet:@max-w-375 @mx-auto">
                <LabelOption v-model="preferredArtistSwitch" data-cy="help-with-artist-option" class="@mb-4" :value="false">
                    Help me find the perfect artist
                </LabelOption>
                <LabelOption v-model="preferredArtistSwitch" data-cy="know-who-i-want-option" :value="true">
                    I already know who I want
                </LabelOption>
                <RequiredFormHelper v-if="preferredArtistSwitch === undefined" class="@mt-2" message="Please select an option"/>
            </div>
            <template v-if="CmsData?.stepCard" #step-tips>
                <StepTipCard :cms-data="CmsData.stepCard.list"/>
            </template>
        </BsFormContainer>
    </div>
</template>

<style>
    @import "@songfinch/customer/stylesheets/includes/pages/_cms-content.pcss";
</style>
